// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".md-field[data-v-4025c993]{border-radius:5px}.container[data-v-4025c993]{align-items:center;flex-direction:column;justify-content:center;padding:1em;text-align:center;width:100%}.container .active-icon[data-v-4025c993]{border:1px solid #19bdc0;border-radius:50%;color:#19bdc0!important;justify-self:center;margin:1em 0;padding:1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
